module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('test', {
    directives: [{
      name: "scroll-response",
      rawName: "v-scroll-response",
      value: ({
        title: '.title',
        contentId: 'content',
        catalogId: 'catalog'
      }),
      expression: "{title:'.title',contentId:'content',catalogId:'catalog'}"
    }]
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5fadd2a3"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 10
// module chunks = 0